import {
  decodeHtmlEntities,
  legacyHtmlText,
  sanitizeLegacyHtml,
} from '../utils/configuredReportLegacyHtml'

import type { LegacyHtmlPreviewProps } from '../types/components'

export function LegacyHtmlPreview({ value }: LegacyHtmlPreviewProps) {
  const raw = String(value ?? '').trim()
  if (!raw) return '—'

  const sanitized = sanitizeLegacyHtml(decodeHtmlEntities(raw))
  const plainText = legacyHtmlText(sanitized)
  const preview =
    plainText.length > 30 ? `${plainText.slice(0, 30)}...` : plainText || '—'

  return (
    <div className="group w-full max-w-full">
      <span className="block truncate group-hover:hidden">{preview}</span>
      {plainText ? (
        <div
          className="hidden w-full rounded-[3px] border border-[#d9e1f1] bg-[#dde7f9] p-[15px] text-left font-['Roboto',sans-serif] text-xs font-medium leading-[1.45] text-[#232946] shadow-[0_3px_6px_rgba(231,233,236,0.5)] group-hover:block [&_p]:mb-2 [&_p]:mt-0 [&_strong]:font-bold"
          dangerouslySetInnerHTML={{ __html: sanitized }}
        />
      ) : null}
    </div>
  )
}
